import {Routes} from '@angular/router';
import {
  MunicipalWasteDisposalBaseInfoSectionComponent
} from './sections/municipal-waste-disposal-base-info-section/municipal-waste-disposal-base-info-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  MunicipalWasteDisposalDeclarationSubjectSectionComponent
} from './sections/municipal-waste-disposal-declaration-subject-section/municipal-waste-disposal-declaration-subject-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {SessionService} from '../../../../services/ssession.service';

export const desktopStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Przedmiot deklaracji',
  'Zgody',
  'Załączniki'
];

export const mobileStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Przedmiot deklaracji',
  'Zgody',
  'Załączniki'
];

export const stages: string[] = SessionService.GetUISettings()?.mobileEmbed ? mobileStages : desktopStages;

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages,
  successUrl: '../przedmiot-deklaracji',
  cancelUrl: '../informacje-podstawowe'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../przedmiot-deklaracji',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const municipalWasteDisposalDesktopRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: MunicipalWasteDisposalBaseInfoSectionComponent
  },
  {
    path: ':appId/informacje-podstawowe',
    component: MunicipalWasteDisposalBaseInfoSectionComponent
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: applicantDataSectionConfig
  },
  {
    path: ':appId/przedmiot-deklaracji',
    component: MunicipalWasteDisposalDeclarationSubjectSectionComponent,
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const municipalWasteDisposalMobileRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: MunicipalWasteDisposalBaseInfoSectionComponent
  },
  {
    path: ':appId/informacje-podstawowe',
    component: MunicipalWasteDisposalBaseInfoSectionComponent
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: applicantDataSectionConfig
  },
  {
    path: ':appId/przedmiot-deklaracji',
    component: MunicipalWasteDisposalDeclarationSubjectSectionComponent,
    data: {
      successUrl: '../zgody'
    }
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: {
      ...agreementsDataSectionConfig,
      removeRegulationsControl: true
    }
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const municipalWasteDisposalRoutes: Routes = SessionService.GetUISettings()?.mobileEmbed ? municipalWasteDisposalMobileRoutes : municipalWasteDisposalDesktopRoutes;
